export const HOME_REDESIGN_BREAKPOINT_PX = 820;
export const HOME_REDESIGN_BREAKPOINT = `${HOME_REDESIGN_BREAKPOINT_PX}px`;

export const HOME_REDESIGN_WIDE_BREAKPOINT_PX = 1024;
export const HOME_REDESIGN_WIDE_BREAKPOINT = `${HOME_REDESIGN_WIDE_BREAKPOINT_PX}px`;

// Caps the two-column text+rail layouts (Irish quality, weekly collections) so they stay centred on wide viewports.
export const HOME_REDESIGN_CONTENT_MAX_WIDTH_PX = 1600;
export const HOME_REDESIGN_CONTENT_MAX_WIDTH = `${HOME_REDESIGN_CONTENT_MAX_WIDTH_PX}px`;

// The Hero offsets down by this to sit flush under the position:fixed TopNav.
export const NAV_HEIGHT_PX = 64;
export const NAV_HEIGHT = `${NAV_HEIGHT_PX}px`;

export const RADIUS_SM = '8px';
export const RADIUS_MD = '16px';

export const MEDIA_DARK_BACKGROUND = '#11161b';
